'use client';

import ScrollAnimation from '@/components/animations/ScrollAnimation';
import LazySection from '@/components/common/LazySection';
import dynamic from 'next/dynamic';
import Hero from './components/Hero';

const ClientsSections = dynamic(() => import('./components/ClientsSections'), {
  ssr: false,
  loading: () => <div className="h-32 bg-gray-50 animate-pulse" />,
});

const Ecommerce = dynamic(() => import('./components/Ecommerce'), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-50 animate-pulse" />,
});

const Lifestyle = dynamic(() => import('./components/Lifestyle'), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-50 animate-pulse" />,
});

const StatsSection = dynamic(() => import('./components/StatsSection'), {
  ssr: false,
  loading: () => <div className="h-64 bg-gray-50 animate-pulse" />,
});

const Gallery = dynamic(() => import('./components/Gallery'), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-50 animate-pulse" />,
});

const FAQ = dynamic(() => import('./components/FAQ'), {
  ssr: false,
  loading: () => <div className="h-64 bg-gray-50 animate-pulse" />,
});

export default function WelcomePage() {
  return (
    <div className="flex flex-col max-w-[1728px] mx-auto bg-white justify-center items-center w-full">
      <ScrollAnimation className="w-full" animation="fade" duration={0.8}>
        <Hero />
      </ScrollAnimation>

      <LazySection className="w-full" rootMargin="200px" minHeight="8rem">
        <ScrollAnimation className="w-full" animation="fadeUp" delay={0.2} duration={0.8}>
          <div data-component="ClientsSections">
            <ClientsSections />
          </div>
        </ScrollAnimation>
      </LazySection>

      <LazySection className="w-full" rootMargin="150px" minHeight="24rem">
        <ScrollAnimation className="w-full" animation="fadeLeft" delay={0.3} duration={0.8}>
          <div data-component="Ecommerce">
            <Ecommerce />
          </div>
        </ScrollAnimation>
      </LazySection>

      <LazySection className="w-full" rootMargin="150px" minHeight="24rem">
        <ScrollAnimation className="w-full" animation="fadeRight" delay={0.2} duration={0.8}>
          <div data-component="Lifestyle">
            <Lifestyle />
          </div>
        </ScrollAnimation>
      </LazySection>

      <LazySection className="w-full" rootMargin="150px" minHeight="16rem">
        <ScrollAnimation className="w-full" animation="scale" delay={0.1} duration={0.8}>
          <div data-component="StatsSection">
            <StatsSection />
          </div>
        </ScrollAnimation>
      </LazySection>

      <LazySection className="w-full" rootMargin="150px" minHeight="24rem">
        <ScrollAnimation className="w-full" animation="fadeUp" delay={0.4} duration={0.8}>
          <div data-component="Gallery">
            <Gallery />
          </div>
        </ScrollAnimation>
      </LazySection>

      <LazySection className="w-full" rootMargin="150px" minHeight="16rem">
        <ScrollAnimation className="w-full" animation="fade" delay={0.2} duration={0.8}>
          <div data-component="FAQ">
            <FAQ />
          </div>
        </ScrollAnimation>
      </LazySection>
    </div>
  );
}
